class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Delegated listeners for controls inside the swappable #CartDrawer section
    // (ship-to-a-customer toggle/checkout redirect, share-this-cart button).
    // renderContents() below replaces #CartDrawer's innerHTML on every add-to-cart,
    // and inline <script> tags inside HTML assigned via .innerHTML never execute - 
    // so any listener wired directly to those buttons in cart-drawer.liquid only
    // ever works once, on the very first page load, before the first AJAX add.
    // Binding on `this` (the <cart-drawer> element itself, which is never replaced)
    // means the listeners keep working no matter how many times the contents inside
    // it get swapped out.
    this.addEventListener('click', this.handleDelegatedClick.bind(this));

    // Live freight estimate: debounced on any ship-to address field input.
    // Delegated the same way as clicks above, for the same reason (the
    // fields live inside the swappable #CartDrawer innerHTML).
    this._freightDebounce = null;
    this.addEventListener('input', this.handleDelegatedShipInput.bind(this));
  }

  handleDelegatedShipInput(e) {
    var shipFieldIds = [
      'sxDrawerShipFirstName',
      'sxDrawerShipLastName',
      'sxDrawerShipAddress1',
      'sxDrawerShipCity',
      'sxDrawerShipZip',
    ];
    if (shipFieldIds.indexOf(e.target.id) === -1) return;
    var self = this;
    clearTimeout(this._freightDebounce);
    this._freightDebounce = setTimeout(function () {
      self.updateDrawerFreightQuote();
    }, 500);
  }

  updateDrawerFreightQuote() {
    var out = this.querySelector('#sxDrawerShipFreight');
    if (!out || !window.StruxaFreight) return;

    var addr = {
      first_name: (this.querySelector('#sxDrawerShipFirstName') || {}).value || '',
      last_name: (this.querySelector('#sxDrawerShipLastName') || {}).value || '',
      address1: (this.querySelector('#sxDrawerShipAddress1') || {}).value || '',
      city: (this.querySelector('#sxDrawerShipCity') || {}).value || '',
      zip: (this.querySelector('#sxDrawerShipZip') || {}).value || '',
      province: (this.querySelector('#sxDrawerShipProvince') || {}).value || '',
        country: 'NZ',
    };

    if (!addr.address1.trim() || !addr.city.trim() || !addr.zip.trim()) {
      out.classList.remove('is-visible');
      out.innerHTML = '';
      return;
    }

    out.classList.add('is-visible');
    out.innerHTML = '<span class="sx-ship-to__freight-loading">Calculating freight for this address…</span>';

    window.StruxaFreight.getRatesForAddress(addr)
      .then(function (rates) {
        var result = window.StruxaFreight.findMatchingRate(rates, addr);
        if (result.rate && result.price != null) {
          out.innerHTML =
            '<div class="sx-ship-to__freight-rate"><span>' +
            result.classification.label +
            '</span><span>NZD $' +
            result.price.toFixed(2) +
            '</span></div>' +
            '<div class="sx-ship-to__freight-note">Estimated freight for this address - select the matching shipping option at checkout if it isn’t already selected.</div>';
        } else {
          out.innerHTML =
            '<span class="sx-ship-to__freight-error">Couldn’t match a rate for this address - freight will be calculated at checkout.</span>';
        }
      })
      .catch(function () {
        out.innerHTML =
          '<span class="sx-ship-to__freight-error">Freight estimate unavailable right now - it will be calculated at checkout.</span>';
      });
  }

  handleDelegatedClick(e) {
    var shipToggle = e.target.closest('#sxDrawerShipToToggle');
    if (shipToggle) {
      var body = this.querySelector('#sxDrawerShipToBody');
      var caret = this.querySelector('#sxDrawerShipToCaret');
      if (body) {
        var open = body.classList.contains('is-open');
        body.classList.toggle('is-open', !open);
        if (caret) caret.innerHTML = open ? '&#9656;' : '&#9662;';
      }
      return;
    }

    if (e.target.id === 'CartDrawer-Checkout' || e.target.closest('#CartDrawer-Checkout')) {
      var enable = this.querySelector('#sxDrawerShipEnable');
      if (!enable || !enable.checked) return; // normal checkout
      var f = {
        first_name: (this.querySelector('#sxDrawerShipFirstName') || {}).value || '',
        last_name: (this.querySelector('#sxDrawerShipLastName') || {}).value || '',
        address1: (this.querySelector('#sxDrawerShipAddress1') || {}).value || '',
        city: (this.querySelector('#sxDrawerShipCity') || {}).value || '',
        zip: (this.querySelector('#sxDrawerShipZip') || {}).value || '',
        phone: (this.querySelector('#sxDrawerShipPhone') || {}).value || '',
          province: (this.querySelector('#sxDrawerShipProvince') || {}).value || '',
      };
      Object.keys(f).forEach(function (k) {
        f[k] = f[k].trim();
      });
      var msgEl = this.querySelector('#sxDrawerShipMsg');
      if (!f.first_name || !f.address1 || !f.city || !f.zip || !f.province) {
        e.preventDefault();
        if (msgEl) {
          msgEl.style.display = 'block';
          msgEl.textContent =
            'Please fill in at least first name, address, city, region and postcode, or untick the box to check out normally.';
        }
        return;
      }
      e.preventDefault();
      var params = new URLSearchParams();
      Object.keys(f).forEach(function (k) {
        if (f[k]) params.set('checkout[shipping_address][' + k + ']', f[k]);
      });
      params.set('checkout[shipping_address][country]', 'New Zealand');
          window.location.href = '/checkout?' + params.toString();
      return;
    }

    var shareBtn = e.target.closest('#CartDrawer-ShareCart');
    if (shareBtn && window.StruxaShare) {
      var msg = this.querySelector('#CartDrawer-ShareCartMsg');
      var orig = shareBtn.textContent;
      shareBtn.disabled = true;
      shareBtn.textContent = 'Copying link…';
      window.StruxaShare.shareCurrentCart(function (err, url, hasCode) {
        shareBtn.disabled = false;
        shareBtn.textContent = orig;
        if (!msg) return;
        msg.style.display = 'block';
        if (err) {
          msg.style.color = '#c0392b';
          msg.textContent = err.message || 'Could not create a share link.';
        } else {
          msg.style.color = '#1c7a1c';
          msg.textContent = hasCode
            ? 'Link copied - your referral code is built in, so it applies automatically when they open it.'
            : 'Link copied - paste it to anyone and they can add these exact items to their cart.';
        }
        setTimeout(function () {
          msg.style.display = 'none';
        }, 5000);
      });
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    // The outer <cart-drawer> element also carries its own 'is-empty' class (see
    // component-cart-drawer.css: cart-drawer.is-empty .drawer__inner/.drawer__header).
    // Only cart.js's quantity-update path was clearing this; the add-to-cart path here
    // never did, so the drawer stayed visually "empty" (blank/collapsed) after adding
    // the very first item to an empty cart. renderContents() only runs after a
    // successful add, so the cart is guaranteed non-empty at this point.
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
